import { Mail, Puzzle, Music, Sparkles } from "lucide-react";

const items = [
  { icon: Mail, title: "A letter to keep", text: "Original writing and little reflections.", tilt: "-rotate-1" },
  { icon: Puzzle, title: "Something to do", text: "Crosswords, word searches, origami and colouring.", tilt: "rotate-1" },
  { icon: Music, title: "Something to listen to", text: "A specially curated monthly playlist.", tilt: "rotate-[-0.5deg]" },
  { icon: Sparkles, title: "Something to keep", text: "Stickers, paper goodies and little surprises.", tilt: "rotate-[0.75deg]" },
];

export const Inside = () => (
  <section id="whats-inside" className="py-28" data-testid="whats-inside-section">
    <div className="max-w-6xl mx-auto px-6">
      <p className="font-hand text-3xl text-amber-700 -rotate-1">inside every envelope</p>
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 mt-3 max-w-2xl leading-tight">
        Every edition is thoughtfully curated around a theme and delivered to your doorstep, with:
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
        {items.map(({ icon: Icon, title, text, tilt }, i) => (
          <div
            key={title}
            className={`group bg-[#FFFDF9] border border-stone-200 rounded-2xl p-7 ${tilt} hover:rotate-0 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-20px_rgba(217,119,6,0.45)] transition-[transform,box-shadow] duration-300 ${i % 2 ? "lg:mt-10" : ""}`}
            data-testid={`inside-item-${i}`}
          >
            <div className="h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center group-hover:bg-amber-300 transition-colors duration-300">
              <Icon className="h-5 w-5 text-stone-900" strokeWidth={1.5} />
            </div>
            <h3 className="font-serif-display text-2xl font-semibold text-stone-900 mt-6">{title}</h3>
            <p className="text-stone-600 mt-2 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
